;(function($, window, undefined) {
    navigator.browser = (function(){
        var ua= navigator.userAgent,
            N= navigator.appName, tem,
            M= ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*([\d\.]+)/i) || [];
        M= M[2]? [M[1], M[2]]:[N, navigator.appVersion, '-?'];
        if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];
        return M.join(' ');
    })();

    var formSent = false,
        openModal = function(id) {
            $(id).addClass('modal-show');
            setTimeout(function() {
                $(id).addClass('animate');
                $('body').addClass('modal-open');
                enableFakeScrollbar();
            }, 20);

            setTimeout(function() {
                $(id).find('input').first().focus();
            }, 500);

            if(typeof _reservio !== 'undefined' && _reservio.runningProduction) {
                ga('send', 'pageview', window.location.href+'sign-up/');
            }
        },
        closeModal = function(id) {
            $(id).removeClass('animate');
            setTimeout(function() {
                $(id).removeClass('modal-show');
                $('body').removeClass('modal-open');
                disableFakeScrollbar();
            }, 300);
        },

        disableForm = function($form) {
            $form.find('input, button')
                .addClass('disabled')
                .prop('disabled', true)
        },

        enableForm = function($form) {
            $form.find('input, button')
                .removeClass('disabled')
                .prop('disabled', false)
        },

        getScrollbarWidth = function() {
            // Create the measurement node
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'scrollbar-measure';
            document.body.appendChild(scrollDiv);

            // Get the scrollbar width
            var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

            // Delete the DIV
            document.body.removeChild(scrollDiv);

            return scrollbarWidth;
        },

        enableFakeScrollbar = function() {
            $('html').css('padding-right', getScrollbarWidth()+'px');
        },

        disableFakeScrollbar = function() {
            $('html').css('padding-right', 0);
        };

    $.validator.addMethod('allowedCharacters', function(value, element) {
        var regex = /[a-zA-Z\-\'\ \sÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏàáâãäåæçèéêëìíîïÐÑÒÓÔÕÖØÙÚÛÜÝÞßðñòóôõöøùúûüýþÿ]/i;
        return regex.test(value);
    });
    $.validator.addMethod('emailValid', function(value, element) {
        var regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        return regex.test(value);
    });

    $(document).ready(function() {
        var $signUpForm = $('#frm-signup');

        $('.modal-signup-button').click(function(e) {
            if (typeof _reservio !== 'undefined' && _reservio.isRu) {
                window.location.href = 'https://www.reservio.com/ru/business/say-no-to-war';
            }
            e.preventDefault();
            setTimeout(function() {
                $('.modal-sign input').first().focus();
            }, 500);
        });

        $(document).on('click', '.modal-close', function(e) {
            $('.modal-backdrop').click();
        });

        $(".modal-sign input")
            .focus(function() {
                if($(".modal-sign").find('.tooltip.in').length == 0){
                    $(this).closest('.form-group').find('.modal-hint').addClass('modal-hint-open');
                }
            })
            .blur(function() {
                $(this).closest('.form-group').find('.modal-hint').removeClass('modal-hint-open');
            });

        $('#frm-signup-userAgent').val(navigator.browser);
        $('#frm-signup-windowSize').val($(window).width() + 'x' + $(window).height());

        var validationSettings = {
            onkeyup: false,
            onfocusout: false,
            rules: {
                name: {
                    required: true,
                    allowedCharacters: true
                },
                email: {
                    required: true,
                    emailValid: true
                },
                password: {
                    required: true,
                    minlength: 6
                }
            },
            messages: {
                name: {
                    required: lang['registration-name-error'],
                    allowedCharacters: lang['registration-name-error-notAllowedCharacters']
                },
                email: {
                    required: lang['registration-email-error'],
                    emailValid: lang['registration-email-error']
                },
                password: {
                    required: lang['registration-password-error'],
                    minlength: lang['registration-password-error']
                }
            },
            invalidHandler: function(form, validator) {
                //$(form.target).find('input').tooltip('hide');
                $(form.target).find('.form-group').removeClass('form-group-error');
                $(form.target).find('.form-error-message').remove();

                if(validator.errorList.length > 0) {
                    var error = validator.errorList[0],
                        $group = $(error.element).closest('.form-group');
                    /*$(error.element)
                        .addClass('error')
                        .attr('data-original-title', error.message)
                        .tooltip('fixTitle')
                        .tooltip('show');*/

                    $group.addClass('form-group-error');

                    if($group.find('.form-error-message').length == 0) {
                        $group.append($('<p class="form-error-message">').text(error.message));
                        $(form.target).find('button[type="submit"]').prop('disabled', false);
                    }
                }
            },
            errorPlacement: function(error, element) {}
        };

        $signUpForm.find('input').tooltip({
            placement: 'right',
            title: 'error',
            trigger: 'manual'
        });

        if($('#frm-signup-name').data('original-title') != '') {
            $('#frm-signup-name').tooltip('show').focus();
        }
        else if($('#frm-signup-email').data('original-title') != '') {
            $('#frm-signup-email').tooltip('show').focus();
        }

        $signUpForm.validate(validationSettings);
    });
})(jQuery, window);
